import LandingPage from '../templates/LandingPage';
import searchIcon from '../../assets/svg/search.svg'

import place1 from '../../assets/images/place1.png'
import place2 from '../../assets/images/place2.png'
import place3 from '../../assets/images/place3.png'
import place4 from '../../assets/images/place4.png'
import place5 from '../../assets/images/place5.png'

import Faq from '../components/card/Faq';
import { useState } from 'react';

function Privacy() {

  const [searchMode, setSearchMode] = useState(false)
  const [search, setSearch] = useState("")

  
  return (
    <LandingPage>
      <div className="px-8 lg:px-16 py-18 flex flex-col items-center section-one">
        <div className="flex w-full lg:w-2/3 mt-32 justify-between">
          <p className="text-yellow text-xl lg:text-3xl font-bold">
            Read our Privacy Policy
          </p>
          {/* <div className={`flex opacity-50 text-white items-start ${searchMode ? "border-b-2" : ""} `}>
            <img src={searchIcon} alt="o" className="self-start mt-2 cursor-pointer" width="30px" onClick={ () => setSearchMode(true)} />
            <div className={`mt-3 flex items-center ml-4 ${searchMode ? "" : "hidden"}`}>
              <input type="text" className="bg-transparent focus:outline-none" focus value={search} onChange={ e => setSearch( e.target.value )}/>
              <div className="text-white bg-brown ml-3 bg-opacity-25 w-6 h-6 rounded-full cursor-pointer flex justify-center items-center" onClick={ () => { setSearch(""); setSearchMode(false) }}>&times;</div>
            </div>
            <span className={`text-xl lg:text-3xl place-self-start ml-4 cursor-pointer ${searchMode ? "hidden" : ""}`} onClick={ () => setSearchMode(true)}>Search</span>
          </div> */}
        </div>
        <div className="flex flex-col w-full lg:w-2/3 mb-5">
          <div className="py-8 px-10 rounded-lg my-4 text-white bg-brown bg-opacity-25">
            <div className="relative">
              <h2 className="font-bold">Why BitcoinAboki? Nothing! Yes… Nothing!</h2>
              <div className={`mt-4 break-normal text-sm transition duration-500 ease-in-out  overflow-hidden `}>
                To get started is quite easy. Sign up here by simply providing few required information and documents. Next you wait for some time to get approval. As soon as your loan is approved, you would be notified via email and SMS. Afterwards, you would provide your account details to get funds. To get started is quite easy. Sign up on here by simply providing few required information and documents.
                <br/>
                To get started is quite easy. Sign up on here by simply providing few required information and documents. Next you wait for some time to get approval. As soon as your loan is approved, you would be notified via email and SMS. Afterwards, you would provide your account details to get funds.
                <br/>
                To get started is quite easy. Sign up on here by simply providing few required information and documents. Next you wait for some time to get approval. As soon as your loan is approved, you would be notified via email and SMS. Afterwards, you would provide your account details to get funds.
                <br/>
                To get started is quite easy. Sign up on here by simply providing few required information and documents. Next you wait for some time to get approval. As soon as your loan is approved, you would be notified via email and SMS. Afterwards, you would provide your account details to get funds. 
              </div>
            </div>
        </div>
        </div> 
      </div>
    </LandingPage>
  );
}

export default Privacy;
